import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as Yup from "yup";

import { AxiosError } from "axios";
import { useState } from "react";
import { Link } from "react-router-dom";
import { baseAppPath, espaceEntrepriseUrl, RECAPTCHA_KEY } from "../../../config/GlobalConfig";
import MgpButton from "../../../elements/MgpButton/MgpButton";
import MgpFormInput from "../../../elements/MgpFormInput/MgpFormInput";
import MgpMessage from "../../../elements/MgpMessage/MgpMessage";
import { login } from "../../../services/AuthService";
import { ILoginRequest } from "../../../services/model";
import { useGoogleReCaptcha } from "react-google-recaptcha-hook";

export default function LoginEntrepriseComponent() {
  const validationSchema = Yup.object().shape({
    username: Yup.string()
      .required("Veuillez renseigner votre email")
      .email("Votre email est incorrect"),
    password: Yup.string()
      .required("Veuillez renseigner votre mot de passe")
      .min(6, "Votre mot de passe est incorrect"),
  });

  const { executeGoogleReCaptcha } = useGoogleReCaptcha(
    `${RECAPTCHA_KEY}`,
    {
      language: 'fr',
      enterprise: true,
      recaptchaNet: true, 
    }
  );;

  const [errorMsg, setErrorMsg] = useState<string | null>();
  const [loading, setLoading] = useState<boolean>(false);

  const {
    register,
    handleSubmit, watch,
    formState: { errors, isSubmitting, isDirty },
  } = useForm<ILoginRequest>({
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues: {
      username: "",
      password: "",
    },
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = async (data: ILoginRequest, e: any) => {
    e.preventDefault();
    //postCredentials();
    setErrorMsg(null);
    setLoading(true);
    try {
      const recaptchaToken = await executeGoogleReCaptcha("login");
      console.log(recaptchaToken);
      data.recaptchaToken = recaptchaToken;
      const payload = await login("EE", data);
      if (payload?.data.accessToken) {
        
        // if login OK, redirect to the caller app
        window.location.href = `${espaceEntrepriseUrl}?token=${payload.data.accessToken}&origin=1`;
        return false;
      }
    } catch (error) {
      setLoading(false);
      const err = error as AxiosError;
      console.log(err);
      if(err.response && (err.response.status === 401 || err.response.status === 400)) {
        setErrorMsg("Votre email ou votre mot de passe est invalide");
      } else {
        setErrorMsg("Une erreur technique est survenue. Veuillez réessayer ultérieurement");
      }
    }
   
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
      {errorMsg && <MgpMessage type="danger" message={errorMsg} hasCloseBtn={false}/>}
      <div className="form-group">
        <MgpFormInput
          label="Mon email"
          type="text"
          register={register}
          id="username"
          icon="account"
          errors={errors}
          disabled={isSubmitting || loading}
        />
      </div>
      <div className="form-group">
        <MgpFormInput
          label="Mon mot de passe"
          register={register}
          type="password"
          id="password"
          icon="oeil"
          iconPosition="right"
          errors={errors}
          disabled={isSubmitting || loading}
        />
         <Link to={baseAppPath + '/oublie-mot-passe'} className="link-bleu m-y-md">Mot de passe oublié ?</Link>
      </div>
      <div className="form-group">
        <MgpButton
          id="submitButton"
          type="submit"
          text="Se connecter"
          disabled={isSubmitting || loading} loading={isSubmitting || loading}
        />
       
      </div>
      
    </form>
  );
}
